//This code exports a function called getNearByRestaurant which takes an object
//with properties as its input parameters: page, search, longitude, latitude.
//This function sends a POST request to an API endpoint GET_NEARBY_RESTAURANT
//with a fixed 50km search radius.

import { GET_NEARBY_RESTAURANT } from '../../axios/appiendPoints';
import { axiosInstanceNext } from '../../axios/axios';

const getNearByRestaurant = async ({ page, search, longitude, latitude }) => {
  let response_obj = { restaurant: [], hasMore: false, search: '', page: page || 1 };
  
  const SEARCH_RADIUS = 50000; // Fixed 50km radius in meters

  const payload = {
    location: [longitude, latitude],
    max_distance: SEARCH_RADIUS,
    page_no: page,
    limit: 10,
    name_filter: search,
  };

  try {
    const response = await axiosInstanceNext.post(GET_NEARBY_RESTAURANT, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (
      response &&
      response?.data &&
      response?.data?.data &&
      response?.data?.data?.nearby_restaurants &&
      response?.data?.data?.nearby_restaurants.length
    ) {
      response_obj.restaurant = [...response?.data?.data?.nearby_restaurants];
      response_obj.hasMore = response?.data?.data?.page_no < response?.data?.data?.total_pages;
    }
    
    response_obj.search = (search || '').trim();
    response_obj.page = page || 1;
  } catch (error) {
    console.error('Error fetching restaurants:', error);
    response_obj.hasMore = false;
  }
  
  return response_obj;
};

export default getNearByRestaurant;
